export default "__VITE_ASSET__DxTf__Cu__"